<div class="pay-now-button " [ngClass]="{ 'display-inline mt-2 mt-10 bn-error-top': isAcmic,'dashboard-paynow-curr-amt': !isAcmic }">
    <!-- <mapfre-modal [modalOptions]="payNowModal" *ngIf="policy?.billingDetails && (policy?.billingDetails[0]?.amountStillDue >= 0 || policy?.billingDetails[0]?.outstandingbalance > 0) && (policy?.days_left_to_expire > 21 || (policy?.policynumber.policyNumber.length === 10) || (policy?.policynumber.policyNumber.length === 6 && policy?.days_left_to_expire <= 21 && !policy?.livoPolicy))"
      [hideModal]="hideModalOnRoute" (hideModalOutput)="resetHideModal()" (click)="hideModal()" 
      (openModal)="preloadPaymentUsToken(policy?.policynumber.policyNumber)">
        <div class="modal-body">
          <ng-container *ngIf="isAcmic; else maHeader">
            <hr class="margin-bottom mb16 no-margin-top"/>                              
          </ng-container>
          <ng-template #maHeader>
            <div class="ma-modal-title">{{'MODAL_MAKE_A_PAYMENT' | translate}}</div>                                                                
          </ng-template>
            <app-payment-alert [policy]="policy" class="max-width-full"></app-payment-alert>
            <div class="modal-body-content">   
              <ng-container *ngIf="isAcmic; else maStatePaynowModal">                                                           
                <div class="row text-center no-margin-horizontal">
                    <div class="col-md-6 col-12 no-padding" *ngIf="policy?.billingDetails[0]?.badCheckCount==='N'">
                        <mapfre-link [additionalClasses]="'w-100 ghost secondary medium-btn no-margin btn'" [routerLink]="['/billing/' +  policy?.policynumber.policyNumber + '/new-payment/']">
                            {{ 'PAY_BY_CHECK' | translate}}
                        </mapfre-link>
                       
                    </div>
                    <div class="col-md-6 col-12 paynow-modal-credit-link" [ngClass]="{'offset-md-3' : policy?.billingDetails[0]?.badCheckCount==='Y' }">                                                           
                        <a class="w-100 mapfre link ghost secondary medium-btn no-margin btn"
                            (click)="onPayByCardBilling(policy?.policynumber.policyNumber,policy?.mailingAddress?.zipCode?.code, policy?.billingDetails[0]?.amountStillDue)">
                            <span class="link-content">
                                {{ 'PAY_BY_CREDIT_CARD' | translate}}
                            </span>
                        </a>                      
                    </div>
                </div>
              </ng-container>  
              <ng-template #maStatePaynowModal>
                <div class="row no-margin-horizontal" *ngIf="policy?.policynumber.policyNumber.length === 10; else as400Policy">
                  <section class="mk-payment-links">
                    <div class="" *ngIf="policy?.billingDetails[0]?.badCheckCount==='N'">                                      
                      
                        <a class="left-side-payment dm-sans-medium font-size medium-font"
                          [routerLink]="['/billing/' +  policy?.policynumber.policyNumber + '/new-payment/']">
                          <img src="./assets/img/images/icon-compensation.svg" width="64px" height="64px" alt="compensation icon" />
                          <span class="mt-4 mb-3 brand-lite-blue">
                            {{ 'CHECKING_SAVINGS_ACCOUNT' | translate}}
                          </span>
                          <span class="mapfre link red-link">
                            Select
                            <img src="./assets/img/images/icon-simple-arrow-right-red.svg" width="24px" height="24px"  alt="simple right arrow icon" />
                          </span>
                        </a>
                    
                    </div>
                    <div class="">                                        
                      
                          <a class="right-side-payment dm-sans-medium font-size medium-font"                                     
                          (click)="onPayByCardBilling(policy?.policynumber.policyNumber,policy?.mailingAddress?.zipCode?.code, policy?.billingDetails[0]?.amountStillDue)"
                          >
                            <img src="./assets/img/images/icon-credit-cards.svg" width="64px" height="64px" alt="credit cards" />
                            <span class="mt-4 mb-3 brand-lite-blue">
                              {{ 'CREDIT_DEBIT_CARD' | translate}}
                            </span>
                            <span class="mapfre link red-link">
                              Select 
                              <img src="./assets/img/images/icon-simple-arrow-right-red.svg" width="24px" height="24px" alt="simple right arrow icon" />
                            </span>
                          </a>                          
                      
                    </div>
                  </section>
                </div> 
                <ng-template #as400Policy>
                  <div class="display-right">
                
                      <form method="POST" ngNoForm target="_blank" [action]="getPayBillLink(policy)">
                        <input class="hides" type="text" name="txtMiscellaneous" [value]="onCreatePaymentForm(policy?.policynumber.policyNumber,policy?.mailingAddress?.zipCode?.code, policy?.billingDetails[0]?.amountStillDue, policy?.format, policy?.company)">
                        <input class="hides" type="text" name="txtAcctNumber" *ngIf="getPayBillSource(policy)!==''" [value]="getCheckDigits(policy?.policynumber.policyNumber,policy?.checkDigits, policy?.company.companyName, policy?.mailingAddress?.zipCode?.code, policy?.format)">
                        <input class="hides" type="text" name="txtSource" [value]="getPayBillSource(policy)">
                        <input type="submit" class="btn mapfre basic primary small-btn modal-small-btn mx-auto" value="Continue">
                     </form>
                  </div>
                </ng-template>                                 
              </ng-template> 
              <div *ngIf="!isAcmic && policy?.policynumber.policyNumber.length === 10" class="display-right margin-top mt32">
                <mapfre-button (click)="resetHideModal()"
                  additionalClasses="ghost secondary small-btn modal-small-btn letter-space-17">{{ "CANCEL" | translate }}
                </mapfre-button>
              </div> 
            </div>
        </div>
    </mapfre-modal> -->
    <mapfre-button *ngIf="policy?.billingDetails && (policy?.billingDetails[0]?.amountStillDue >= 0 || policy?.billingDetails[0]?.outstandingbalance > 0) && (policy?.days_left_to_expire > 21 || (policy?.policynumber.policyNumber.length === 10) || (policy?.policynumber.policyNumber.length === 6 && policy?.days_left_to_expire <= 21 && !policy?.livoPolicy))"
        additionalClasses="basic primary x-small-btn paynow-btn" (click)="payNow()">
        {{ 'PAY_NOW' | translate }}
    </mapfre-button>
    <mapfre-button *ngIf="policy?.billingDetails && policy?.policyStatus === 'ACTIVE' && (policy?.billingDetails[0]?.amountStillDue >= 0 || policy?.billingDetails[0]?.outstandingbalance > 0) && policy?.days_left_to_expire <= 21 && policy?.policynumber.policyNumber.length === 6 && policy?.livoPolicy"
        additionalClasses="basic primary w100 h24 no-padding x-small-btn pay-now-modal  modal-medium modal-dialog center-on-page" (click)="showToast()">
        {{ 'PAY_NOW' | translate }}
    </mapfre-button>
</div>